<template>
  <div>
    <b-row>
      <b-col
        cols="12"
      >
        <b-card title="Dijital Katalog">
          <pre-loading v-if="uploading" />
          <template v-else>
            <b-embed
              v-if="itemData.catalog"
              type="iframe"
              aspect="16by9"
              :src="baseURL + '/media/about/' + itemData.catalog"
              allowfullscreen
            />
            <b-form-file
              id="desktop-catalog"
              v-model="catalog"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!catalog"
                @click="uploadFile('desktop')"
              >
                <FeatherIcon icon="UploadIcon" />
                Katalog Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BEmbed,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'CatalogCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BEmbed,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      catalog: null
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile(type) {
      let file = ''
      if (type === 'desktop') {
        file = this.catalog
      }
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: file,
        folder: 'about',
      })
        .then(response => {
          if (response.filename) {
            if (type === 'desktop') {
              this.itemData.catalog = response.filename
            }
          }
        })
    },
  },
}
</script>
